import { forwardRef } from 'react';

import { isDesktopOperatingSystem } from '@repo/detection';
import { Button } from '@repo/ui/components/Buttons';
import { IconSwitcher } from '@repo/ui/components/Icon';

import {
  useMobileRoutingStore,
  mobileRoutingStoreSelector,
} from 'stores/mobileRoutingStore';

import { IconWrapper, StyledLink } from './style';
import { LinkButtonProps } from './types';

const LinkButton = forwardRef<HTMLButtonElement, LinkButtonProps>(
  (
    {
      isButton,
      buttonAction,
      desktopOnly,
      href,
      rel,
      download,
      scroll = true,
      target = '_self',
      rightIcon,
      ...props
    },
    ref
  ) => {
    const openMobileModal = useMobileRoutingStore(
      mobileRoutingStoreSelector.openModal
    );
    const _isMobile = !isDesktopOperatingSystem();

    if (isButton && buttonAction) {
      return (
        <Button
          ref={ref}
          {...props}
          name="triggerLinkActionButton"
          onClick={buttonAction}
        />
      );
    }
    if (desktopOnly && _isMobile) {
      return (
        <Button
          ref={ref}
          {...props}
          name="openMobileModalButton"
          onClick={openMobileModal}
        />
      );
    }
    if (!href || props.disabled) {
      return (
        <Button
          ref={ref}
          as="span"
          name="disabledLinkButton"
          style={{ pointerEvents: 'none' }}
          {...props}
        />
      );
    }

    return (
      <StyledLink
        download={download}
        href={href}
        rel={rel}
        scroll={scroll}
        style={{ width: props.width }}
        target={target}
      >
        <Button ref={ref} name="linkNavigationButton" {...props} />
        {rightIcon && (
          <IconWrapper>
            <IconSwitcher
              height={rightIcon.height}
              icon={rightIcon.component}
            />
          </IconWrapper>
        )}
      </StyledLink>
    );
  }
);

LinkButton.displayName = 'LinkButton';

export default LinkButton;
